// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-N":"N_dpu-detail-N__ZZCXh"};